import { Injectable } from '@angular/core';

import { UrlService } from '@service/url/url.service';
import { RestService, IS_NOT_NULL_OR_UNDEFINED, IS_NOT_EMPTY } from 'cargo-chief-commons';
import { Cargochief } from '@service/cargochief/cargochief.service';

import { CARGOCHIEF_KEYS } from '@domain/constants/app-variables';

@Injectable({
	providedIn: 'root',
})
export class BaConfigService {
	constructor(
		private urlService: UrlService,
		private restService: RestService,
		public cargochief: Cargochief
	) {}

	async setBaConfig() {
		const response = await this.restService
			.GET(this.urlService.getBookingAutomationConfigurationData())
			.toPromise();
		if (response?.data) {
			this.cargochief.setItem({
				[CARGOCHIEF_KEYS.BA_CONFIG]: response.data,
			});
		}
	}

	get IS_BA_ENABLED(): boolean {
		let result: boolean = false;
		const baConfig = this.getBAConfig();
		if (baConfig?.bookingAssistantEnabledValue) {
			result = Boolean(JSON.parse(baConfig.bookingAssistantEnabledValue));
		}
		return result;
	}

	getBAConfig(): any {
		const baConfig: any = localStorage.getItem(CARGOCHIEF_KEYS.BA_CONFIG);
		if (IS_NOT_NULL_OR_UNDEFINED(baConfig) && IS_NOT_EMPTY(baConfig)) {
			return JSON.parse(baConfig);
		}
		return null;
	}
}
